import React, { useState } from "react";

import { FaLinkedin, FaSpotify, FaYoutube } from "react-icons/fa";

import ApiRequest from "./../api/ApiRequest";
import { API_AUTH_TYPES, API_ROUTES } from "./../api/apiConstants";

import { ArrowRightIcon, CheckCircleIcon, } from "@heroicons/react/outline";

const navigation = [
  {
    title: 'Support',
    links: [
      { name: 'Pricing', href: '/#pricing' },
      { name: 'FAQ', href: '/faq' },

    ],
  },
  {
    title: 'Company',
    links: [
      { name: 'Our Story', href: '/our-story' },
      { name: 'Blog', href: '/blog' },
      { name: 'Security', href: '/security' },
      { name: 'Careers', href: '/careers' },
      { name: 'Contact Us', href: '/faq#contact-us' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { name: 'Form CRS', href: 'https://reports.adviserinfo.sec.gov/crs/crs_304612.pdf' },
      { name: 'Notice and Disclamer', href: '/legal/notice_and_disclamer' },
      { name: 'Privacy Policy', href: 'https://drive.google.com/file/d/1wll2KkNkfLGgaRUUW7yr0PQB3EpDang5/view?usp=drive_link' },
      { name: 'Terms Of Use', href: '/legal/terms_of_use' },
      { name: 'Additional Terms', href: '/legal/additional_terms' },
    ],
  },



]
const social = [
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/abundowealth/',
    icon: (props) => (
      <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
        <path
          fillRule="evenodd"
          d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/abundowealth/',
    icon: (props) => (
      <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
        <path
          fillRule="evenodd"
          d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
  {
    name: 'X',
    href: 'https://twitter.com/abundowealth',
    icon: (props) => (
      <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
        <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z" />
      </svg>
    ),
  },
  {
    name: 'Spotify',
    href: 'https://open.spotify.com/playlist/6rRy801ckdpynDz9sWHzIX',
    icon: (props) => (
      <FaSpotify {...props} />
    ),
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/abundowealth/',
    icon: (props) => (
      <FaLinkedin {...props} />

    ),
  },
  {
    name: "Youtube",
    href: "https://www.youtube.com/@abundowealth",
    icon: (props) => (
      <FaYoutube {...props} />
    ),
  },
]
export default function Example() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false)
  const emailjsApi = new ApiRequest(API_ROUTES.EMAIL_JS, API_AUTH_TYPES.NONE);
  const beehiivApi = new ApiRequest(API_ROUTES.BEEHIIV, API_AUTH_TYPES.NONE);

  const handleSubmit = async (e) => {


    try {
      e.preventDefault();
      setIsSuccess(true)

      const response = await emailjsApi.post({
        endpoint: "send_email",
        body: {
          template_id: "contact_us",
          template_params: { name: 'new newsletter contact', email, message: 'New newletter contact' },
        },
      });
      await beehiivApi.post({
        endpoint: 'newsletter',
        body: {
          email,
        },
      })
      setName("");
      setEmail("");
      setMessage("");

      setTimeout(() => {
        setIsSuccess(false)
      }, 1000 * 5);
      return;
    } catch (error) {
      console.error(error);
      setTimeout(() => {
      }, 1000 * 5);
    }
  };
  return (
    <footer className="bg-primary-800" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto   pb-8  px-4 sm:px-6 lg:px-10 font-lato ">
        <div className="flex flex-col xl:flex-row justify-center px-5 sm:px-10 md:px-16  lg:px-24 py-16  sm:py-20 lg:py-24">
          <ul className="grid grid-cols-2 md:grid-cols-3 lg:gap-x-32 lg:mr-32 ">
            {navigation.map((category) => (

              <li className="">
                <h3 className="text-lg font-semibold leading-6 text-white">{category.title}</h3>
                <ul className="mt-3 space-y-2">
                  {category.links.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className="text-base leading-6 text-gray-300 hover:text-gray-100">
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
            )
            )}
          </ul>
          <div className="mt-10 xl:mt-0">
            <h3 className="text-lg font-semibold leading-6 text-white">Subscribe to our newsletter</h3>
            <p className="mt-2 text-base leading-6 text-gray-300">
              The latest news, articles, and resources, sent to your inbox monthly.
            </p>
            <form className="mt-6 flex max-w-md items-center">
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                type="email"
                name="email-address"
                id="email-address"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full min-w-0 appearance-none rounded-md border-0 bg-white px-3 py-1.5 text-base text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-sky-blue-200 sm:w-64 sm:text-sm sm:leading-6 xl:w-full"
                placeholder="you@gmail.com"
              />
              <div className="ml-4 sm:mt-0 flex-shrink-0">
                <button
                  onClick={handleSubmit}
                  className="flex items-center  "
                >
                  {isSuccess ? <CheckCircleIcon className="h-7 w-7 mt-1 text-white" /> : <ArrowRightIcon className='h-7 w-7 mt-1 text-white' />}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="border-t border-white pt-8  md:flex md:items-center md:justify-between">
          <div className="flex space-x-6 md:order-2">
            {social.map((item) => (
              <a key={item.name} href={item.href} target="_blank" rel='noopener noreferrer' className="text-white hover:text-white">
                <span className="sr-only">{item.name}</span>
                <item.icon className="h-6 w-6" aria-hidden="true" />
              </a>
            ))}
          </div>
          <p className="mt-8 text-xs leading-5 text-white md:order-1 md:mt-0">
            &copy; 2025 Abundo Wealth Inc. All rights reserved worldwide.
          </p>
        </div>
      </div>
    </footer>
  )
}



